import {Text} from "@fluentui/react";

const DefaultTupleCard = (props: any) => {

    return (<Text variant={'small'}>{props.text}</Text>)
}

export default DefaultTupleCard